import axios from 'axios';

export async function newFormTemplate(file: File) {
	const payload = new FormData();
	const headers = { 'content-type': 'multipart/form-data' };
	payload.append('template', file);
	return axios.post('/api/datasharingagreementform', payload, { headers });
}

export async function getReport() {
	const headers = { responseType: 'blob' };
	return axios.get('/api/datasharingagreementform/report', { headers });
}

export const DataSharingAgreementFormService = {
	newFormTemplate,
	getReport,
};
